import { render } from "./leavetype-model.vue?vue&type=template&id=432ac652"
import script from "./leavetype-model.vue?vue&type=script&lang=js"
export * from "./leavetype-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__